import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {Tabs, Tab} from 'material-ui/Tabs';
import InviteUserGeneralForm from './inviteUserGeneralForm';
import InviteUserFormRoles from './inviteUserFormRoles';
import InviteUserFormTeamsUnits from './inviteUserFormTeamsUnits';
import TabFormValidationBadge from '../../portal/tabFormValidationBadge';

@inject('translationsStore', 'addEditUserStore') @observer
export default class InviteUserTab extends Component {
    state = {
        selectedTabId: -1
    };

    handleActive = (tab) => {

        this.setState({
            selectedTabId: tab.props['value']
        });
    }

    componentDidMount() {

        this.setState({
            selectedTabId: 1
        });
    }

    render(){

        const tabStyleProps = {
            className: `tab-dialog`,
            buttonStyle: { color: '#372f51' },
            style: {backgroundColor: '#fff'}
        };

        const generalTitle = this.props.translationsStore.translate('GENERAL');
        const organizationUnitsTitle = this.props.translationsStore.translate('TEAMS');
        const rolesTitle = this.props.translationsStore.translate('ROLES');

        let form = <InviteUserGeneralForm />;

        const tabs = [{
                id: 1,
                title: generalTitle,
                component: form,
                icon: null,
            },
            {
                id: 2,
                title: organizationUnitsTitle,
                component: <InviteUserFormTeamsUnits />,
                icon: <TabFormValidationBadge isFormComplete={this.props.addEditUserStore.organizationUnitsFormComplete} />,
            },
            {
                id: 3,
                title: rolesTitle,
                component: <InviteUserFormRoles />,
            } 
        ];

        return (
            <div style={{position: 'relative'}}>
                <Tabs className='tabs-dialog' contentContainerClassName='tabs-dialog-content-wrapper'>
                    {
                        tabs.map((tab, index) => {

                            return <Tab key={index}
                                {...tabStyleProps}
                                value={tab.id}
                                className={`tab-dialog${this.state.selectedTabId == tab.id ? ' selected' : ''}`}
                                style={{ backgroundColor: '#fff' }}
                                label={tab.title}
                                icon={tab.icon}
                                onActive={this.handleActive}>
                                <div>
                                    {tab.component}
                                </div>
                            </Tab>;
                        })
                    }
                </Tabs>
            </div>
        );
    }
}